import { faClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';

interface Props {
  ttl: number;
  onTimeout: () => void;
}
let interval: any = null;
export default function BookingTimeout({ ttl, onTimeout }: Props) {
  const [second, setSecond] = React.useState<number>(ttl);

  React.useEffect(() => {
    if (ttl > 0) {
      setSecond(ttl);
      if (interval) {
        window.clearInterval(interval);
      }
      interval = window.setInterval(() => {
        setSecond(s => --s);
      }, 1000);
    } else {
      setSecond(0);
      if (interval) {
        window.clearInterval(interval);
      }
    }
  }, [ttl]);

  React.useEffect(() => {
    if (second <= 0) {
      if (interval) {
        window.clearInterval(interval);
      }
      onTimeout();
    }
  }, [second]);

  const timeFormatted = React.useMemo(() => {
    let duration = moment.duration(second, 'second');
    return `${duration.minutes()}:${duration.seconds()}`;
  }, [second]);
  return (
    <div className="bg-error-1">
      <div className="container text-center">
        <span className="text-14 text-red-1 py-5 fw-500 ">
          <FontAwesomeIcon icon={faClock} className="mr-10" />
          {`Payment completion time ${timeFormatted}`}
        </span>
      </div>
    </div>
  );
}
